<template>

    <div class="modal fade" :id="'popUpSchedaAzienda' + rs" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-xl"> 
            <div class="modal-content"> 

                <div class="modal-header bg-secondary text-white border-0">
					<h5 class="modal-title">
						<i class="ph-list icon-modal-size me-2"></i><span class="me-2">Scheda:</span>{{azienda.personaGiuridica.ALIAS}} 
					</h5>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
                </div>
                <div class="modal-body p-2" style="height: 33rem;"> 
                    
                    <div class="card card-noshadow mb-0">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-2 col-lg-2">
		                            <div class="sidebar-content">
                                        <div class="card sidebar-section-body text-center p-2 mb-0">
		                                    <div class="card-img-actions d-inline-block">
		                                        <img v-if="azienda.ID_AZIENDA > 0 && azienda.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('AZIENDE',azienda.URL_AVATAR)" class="img-fluid rounded-circle" alt="" width="150" height="150" />
		                                        <span v-if="azienda.URL_AVATAR == 'placeholder.jpg' || azienda.ID_AZIENDA == 0">
		                                            <img src="../assets/images/placeholders/placeholder.jpg" class="img-fluid rounded-circle" width="150" height="150" alt="">
		                                        </span>
		                                        <div class="card-img-actions-overlay card-img rounded-circle">
		                                            <a href="#" class="btn btn-outline-white btn-icon rounded-pill" v-on:click="openUploadAzienda(this.azienda)">
		                                                <i class="ph-pencil"></i>
		                                            </a>
		                                        </div>
		                                    </div>
		                                </div>
		
		                                <ul class="nav nav-sidebar" role="tablist">
		                                    <li class="nav-item" role="presentation">
		                                        <a href="#profile" class="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab" style="padding-left: 5px;">
		                                            <i class="ph-globe me-2"></i>Anagrafica
		                                        </a>
		                                    </li>
		                                    <li v-show="azienda.ID_AZIENDA > 0" class="nav-item" role="presentation">
		                                        <a href="#users" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" style="padding-left: 5px;" tabindex="-1">
		                                            <i class="ph-users me-2"></i>Collaboratori
		                                        </a>
		                                    </li>
		                                    <li v-show="azienda.ID_AZIENDA > 0" class="nav-item" role="presentation">
		                                        <a href="#testi" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" style="padding-left: 5px;" tabindex="-1">
		                                            <i class="ph-text-t me-2"></i>Contenuti
		                                        </a>
		                                    </li>
		                                    <li v-show="azienda.ID_AZIENDA > 0" class="nav-item" role="presentation">
		                                        <a href="#password" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" style="padding-left: 5px;" tabindex="-1">
		                                            <i class="ph-gear me-2"></i>Configurazioni
		                                        </a>
		                                    </li>
		                                    <li v-show="azienda.ID_AZIENDA > 0" class="nav-item" role="presentation">
		                                        <a href="#logs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" style="padding-left: 5px;" tabindex="-1">
		                                            <i class="ph-code me-2"></i>Log Accessi
		                                        </a>
		                                    </li>
		                                </ul>
		                            </div>
                                
                                </div>
                                <div class="col-12 col-md-10 col-lg-10">
			                        <div class="tab-content flex-fill">
			                            
			                            <div class="tab-pane fade active show" id="profile" role="tabpanel">
			                               <h5 class="label-bar"><i class="fad fa-globe fa-fw me-1"></i> Anagrafica</h5>
			                               <div class="box-utenti">  
			
				                                <div class="row" v-show="azienda.ID_AZIENDA == 0">
			                                        <div class="col-6 col-md-4 form-group-1">
			                                            <label class="text-danger custom-control custom-control-right">Tipo Azienda:</label>
			                                            <select class="form-select form-select-sm" data-placeholder="Tipo Agenzia" :tabindex="1" v-model="azienda.FK_ID_TIPOLOGIA_AZIENDA">
			                                                <option v-for="t in (tipo == 1 ? $root.arrayTipoAgenzia : $root.arrayTipoFornitore)" v-bind:value="t.ID_OPZIONE_TIPOLOGICA" v-bind:key="t.ID_OPZIONE_TIPOLOGICA">{{ t.DESCRIZIONE }}</option>
			                                            </select> 
			                                        </div>
												</div>
			                                    <PersonaGiuridica :ref="'pg'" :dim="'sm'" v-model="azienda.personaGiuridica"></PersonaGiuridica>
			                                    <!--
			                                    <div class="row">
			                                        <div class="col-6 col-md-4 form-group-1">
			                                            <label class="text-danger custom-control custom-control-right">Stato</label>
			                                            <select class="form-select form-select-sm" data-placeholder="Tipo Agenzia" :tabindex="1" v-model="azienda.FLG_ATTIVO">
			                                                <option v-bind:value="0">NON ATTIVO</option>
			                                                <option v-bind:value="1">ATTIVO</option>
			                                            </select> 
			                                        </div>
			                                    </div>
			                                    -->
				                            </div>
			                            </div>	
			
			                            <div class="tab-pane fade" id="users" role="tabpanel">
			                                <h5 class="label-bar"><i class="fad fa-users fa-fw me-1"></i> Elenco Collaboratori</h5>
			                                <div class="tableFixHead tableFixHeadRoles">
			                                    <table class="table table-hover table-striped table-bordered">
			                                        <thead class="sticky-top">
			                                            <tr class="bg-secondary text-white">
			                                                <th class="table-head-sm-2" style="width: 6.6%;">#</th> 
			                                                <th class="table-head-sm-2" style="">Cognome e Nome</th> 
			                                                <th class="table-head-sm-2" style="width: 20%;">Ruolo</th>  
			                                            </tr>
			                                        </thead> 
			                                        <tbody>
			                                            <tr v-for="utente in azienda.utenti" v-bind:key="utente.ID_UTENTE">
			                                                <td><img v-if="utente.ID_UTENTE > 0" :src="filters.getImgPath('USERS',utente.URL_AVATAR)" class="rounded shadow" alt="" :width="30" ></td>
			                                                <td>

			                                                    <div class="d-flex flex-wrap align-items-center justify-content-between">
			                                                        <span class="text-primary fw-bold text-uppercase cursor-pointer" v-on:click="modificaUtente(utente)">{{ utente.SESSO == 1 ? 'Mr' : 'Mrs' }} - {{ utente.NOME }} {{ utente.COGNOME }}</span>
			                                                        <span class="badge badge-danger badge-xs font-size-xs cursor-pointer" v-on:click="showNoteUtente(utente)" style="padding: 0.20rem 0.3rem !important;"><i class="fal fa-info fa-fw"></i> Note</span>
			                                                    </div>
			                                                    <a class="badge bg-light rounded-0 badge-xs font-size-xs text-dark me-1" style="border: 1px #dddddd solid; padding: 0.18rem 0.3rem !important;" v-bind:href="`mailto:${utente.EMAIL}`"><i class="fal fa-envelope fa-fw"></i> {{ utente.EMAIL }}</a>
			                                                    <a class="badge bg-light rounded-0 badge-xs font-size-xs text-dark" style="border: 1px #dddddd solid; padding: 0.18rem 0.3rem !important;" v-bind:href="`tel:${utente.TELEFONO}`"><i class="fal fa-phone fa-fw"></i> {{utente.TELEFONO}}</a>
			                                                    <a v-if="$root.isGod" class="badge bg-light rounded-0 badge-xs font-size-xs text-dark cursor-pointer float-end" style="border: 1px #dddddd solid; padding: 0.18rem 0.3rem !important;margin-top: 2.5px; " v-on:click="resetPassword(utente)"><i class="fal fa-key fa-fw" data-popup="tooltip" title="" data-original-title="Reset Password"></i> Reset Password</a>
			                                                </td> 
			                                                <td style="">
			                                                    Titolare
			                                                    <span class="badge badge-secondary badge-xs font-size-xs cursor-pointer" v-on:click="login(utente)"><i class="fal fa-sign-in-alt fa-fw"></i> Accedi ora</span>
			                                                </td>
			                                            </tr>
			                                        </tbody>
			                                    </table>
			                                </div>
			                            </div>	
			
			                           	<div class="tab-pane fade" id="testi" role="tabpanel">
			                                <h5 class="label-bar"><i class="fad fa-text fa-fw me-1"></i> Gestione Contenuti</h5>
			                                <div class="box-utenti">
			                                    <div class="alert alert-primary border-0 alert-dismissible fade show">
													Scrivi in questo spazio, note inerenti l'utente.
													<button type="button" class="btn-close" data-bs-dismiss="alert"></button>
			                                    </div>
			                                    <ckeditor :editor="editor" v-model="azienda.NOTE" :config="editorConfig"></ckeditor> 
			                                </div>
			                            </div>	  
			
			                            <div class="tab-pane fade" id="password" role="tabpanel">
			                                <h5 class="label-bar"><i class="fad fa-cogs fa-fw me-1"></i> Configurazioni Personali</h5>
			                                <!-- 17/04/2023 - UTILIZZIAMO LA CORE_OPZIONI_UTENTE (IN QUESTA TABELLA NON CI SONO RIFERIMENTI AD OPZIONI 
			                                     REALMENTE CODIFICATE MA NEL CAMPO LABEL VIENE INSERITA LA DESCRIZIONE DELL'OPZIONE MENTRE NEL CAMPO VALORE IL RELATIVO VALORE) -->
			                                <div class="box-users">
			                                    <form action="#">
			                                        <div class="row mb-2">
			                                            <label class="col-12 col-md-3 col-lg-3 col-form-label">SITO WEB:</label>
			                                            <div class="col-6 col-md-2 col-lg-1">
															<span class="btn btn-light btn-sm" v-on:click="azienda.enti = filters.select2AddAll(azienda.enti,filters.toSelect2($root.arrayEnti,'ID_ENTE','LABEL'))">Tutti</span>
														</div>
			                                            <div class="col-6 col-md-7 col-lg-8">
			                                                <Select2 style="padding: 0px 0px 0px 10px; line-height: 19px !important;" :multiple="true" v-bind:options="filters.toSelect2($root.arrayEnti,'ID_ENTE','LABEL')" v-model="azienda.enti" :tabindex="17"></Select2>
			                                            </div>
			                                        </div>
			                                        <div class="row mb-2">
			                                            <label class="col-12 col-md-3 col-lg-3 col-form-label">PROMOTORE:</label>
			                                            <!--
			                                            <div class="col-lg-9">
			                                                <div class="col-lg-9">
			                                                    <select v-model="azienda.FK_ID_PROMOTORE" class="form-select form-select-sm" :disabled="opzione.FLG_MODIFICABILE == 0 && $root.utente.FK_ID_LIVELLO > 1">
			                                                        <option v-for="opz in opzione.OPZIONI" v-bind:value="opz.ID_OPZIONE_TIPOLOGICA" v-bind:key="opz.DESCRIZIONE">{{ opz.DESCRIZIONE }}</option>
			                                                    </select>
			                                                </div>
			                                            </div>
			                                            -->
			                                        </div>
			                                        <div class="row mb-2" v-for="opzione in arrayOpzioniAzienda" v-bind:key="opzione.ID_OPZIONE" > <!-- v-show="opzione.FK_ID_LIVELLO == utente.FK_ID_LIVELLO" -->
			                                            <template v-if="opzione.FK_ID_TIPO == this.tipo">
			                                                <label class="col-12 col-md-3 col-lg-3 col-form-label">{{ opzione.LABEL }}:</label>
			                                                <div class="col-12 col-md-9 col-lg-9">
			                                                    <select v-model="azienda[opzione.CAMPO]" class="form-select form-select-sm" :disabled="opzione.FLG_MODIFICABILE == 0 && $root.utente.FK_ID_LIVELLO > 1">
			                                                        <option v-for="opz in opzione.OPZIONI" v-bind:value="opz.ID_OPZIONE_TIPOLOGICA" v-bind:key="opz.DESCRIZIONE">{{ opz.DESCRIZIONE }}</option>
			                                                    </select>
			                                                </div>
			                                            </template>                                            
					                                </div>
			                                    </form>
				                            </div>
				                        </div>	
			
			                            <div class="tab-pane fade" id="logs" role="tabpanel">
			                                <h5 class="label-bar mb-1"><i class="fad fa-code fa-fw me-1"></i> Log Accessi</h5>
			                                <div class="row mb-1">
			                                    <div class="col-6 col-md-4">
			                                        <select class="form-select form-select-sm">
			                                            <option value="opt1">Seleziona Data</option>
			                                            <option value="opt2">Option 2</option>
			                                            <option value="opt3">Option 3</option>
			                                            <option value="opt4">Option 4</option>
			                                            <option value="opt5">Option 5</option>
			                                            <option value="opt6">Option 6</option>
			                                            <option value="opt7">Option 7</option>
			                                            <option value="opt8">Option 8</option>
			                                        </select>
			                                    </div>
			                                    <div class="col-6 col-md-4">
			                                        <select class="form-select form-select-sm">
			                                            <option value="opt1">Seleziona Modulo</option>
			                                            <option value="opt2">Option 2</option>
			                                            <option value="opt3">Option 3</option>
			                                            <option value="opt4">Option 4</option>
			                                            <option value="opt5">Option 5</option>
			                                            <option value="opt6">Option 6</option>
			                                            <option value="opt7">Option 7</option>
			                                            <option value="opt8">Option 8</option>
			                                        </select>
			                                    </div>
			                                    <div class="d-block d-xl-none col-md-4">
			                                    </div>
			                                </div>
			                                <div class="tableFixHead tableFixHeadRoles">
			                                    <table class="table table-bordered table-hover table-striped table-togglable">
			                                        <thead class="sticky-top">
			                                            <tr class="bg-secondary text-white">
			                                                <th class="p-1 fs-12" style="width:20%;"> Data </th>
			                                                <th class="p-1 fs-12" style="width:20%;">Modulo</th>
			                                                <th class="p-1 fs-12">Pagina</th>
			                                                <th class="p-1 fs-12 text-center" style="width:5%;">Azioni</th>
			                                            </tr>
			                                        </thead>
			                                        <tbody>
			                                            <tr>
			                                                <td class="p-1 font-size-xs">30/12/2021 12:58:01</td>
			                                                <td class="p-1 font-size-xs"><span class="text-primary fw-bold">Home</span></td>
			                                                <td class="p-1 font-size-xs">op=users_list</td>
			                                                <td class="p-1 text-center">
			                                                    <a href="#" class="badge badge-flat border-secondary text-secondary"><i class="fal fa-eye"></i></a>
			
			                                                </td>
			                                            </tr>
			                                        </tbody>
			                                    </table>
			                                </div> 
			                            </div>

			                        </div> 
								</div>
							</div>
						</div>            
                    </div>
					
                </div>
                <div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
                    <button class="btn btn-secondary float-end" v-on:click="salvaAzienda()"><i class="fal fa-save fa-fw me-1"></i> Salva Modifiche </button>                                   
                </div>
            </div>
        </div>
    </div>	
				   

    <div class="modal fade" id="modalPassword" role="dialog"  tabindex="-1" >
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-secondary text-white">
					<h6 class="modal-title"><i class="fa fa-fw fa-key fa-fw"></i> Reset Password</h6>
					<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">X</button>
				</div>
				<div class="modal-body">
					<div class="form-group">
						<label>Nuova password</label>
						<input type="password" class="form-control" placeholder="Nuova password" v-model="utenteSelezionato.PASSWORD">
					</div>
					<div class="form-group">
						<label>Conferma password</label>
						<input type="password" class="form-control" placeholder="Conferma nuova password" v-model="utenteSelezionato.CONFERMA_PASSWORD">
					</div>
				</div>
				<div class="modal-footer modal-footer-1 bg-light">
                    <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal"><i class="fal fa-sign-out-alt fa-fw"></i> CHIUDI</button>
					<button type="button" class="btn btn-success float-end btn-sm" v-on:click="doResetPassword()"><i class="fal fa-save fa-fw"></i> SALVA</button>
				</div>
			</div>
		</div>
	</div> 
 
	<div class="modal fade" id="modalNoteUtente" role="dialog"  tabindex="-2" >
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-secondary text-white">
					<h6 class="modal-title"><i class="fa fa-fw fa-key fa-fw"></i> NOTE IMPORTANTI</h6>
					<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">X</button>
				</div>
				<div class="modal-body">

					<div class="textarea rounded" v-html="utenteSelezionato.NOTE"></div>

				</div>
				<div class="modal-footer modal-footer-1 bg-light">                                  
                    <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal"><i class="fal fa-sign-out-alt fa-fw"></i> CHIUDI</button>
				</div>
			</div>
		</div>
	</div>

    <AvatarUploader ref="avatarUpd" folder="AZIENDE" title="Immagine Azienda" :modalId="'popUpUploadAvatarAzienda' + rs" @uploaded="onAvatarUploaded"></AvatarUploader>

    <SchedaUtente :ref="'schedaUtente'" @updateGriglia="refreshAzienda()"></SchedaUtente>

</template>



<script>	 	 

//import PersonaFisica from '@/components/common/PersonaFisica.vue';
import PersonaGiuridica from '@/components/common/PersonaGiuridica.vue';
import SchedaUtente from '@/components/SchedaUtente.vue';
import Select2 from '@/components/utils/Select2.vue'
import AvatarUploader from '@/components/utils/AvatarUploader.vue'
import ClassicEditor from '@/utils/CustomCKEditor';


export default {
    name:"SchedaAzienda",
    emits:['aziendaSalvata','avatarAggiornato'],
    props:['tipo'],
    components:{
        //PersonaFisica,
        PersonaGiuridica,
        SchedaUtente,
        Select2,
        AvatarUploader,

    },
    data:function(){
        return{
			filters:global.filters,
            azienda : {personaGiuridica:{}},
            utenteSelezionato:{personaFisica:{}}, 
            arrayTipoAzienda:new Array(),
            arrayNetwork:new Array(),
            //CORRISPONDENZA CON ID DELLE TIPOLOGICHE
            arrayGruppi:new Array(),
            arrayOpzioniTipologiche:new Array(),
            arrayOpzioniAzienda:new Array(),
			rs : utils.generateRandomString(30),
		    tabSelezionato : "datiAziendali",
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
                // The configuration of the editor.
            },
			arrayCommissioni:new Array(),
			commissioneMassiva:0,
        }
    },

    methods:{
        chiudi() {
            this.filters.closePopUp('popUpSchedaAzienda' + this.rs);
        },
        openSchedaAzienda: function(azienda){
            if (azienda.ID_AZIENDA == 0){
                this.azienda = utils.clone(azienda);
                this.filters.openPopUp("popUpSchedaAzienda" + this.rs);
                this.getTipologicaTipoAzienda();
            }
            else{
                var params = {ID_AZIENDA:azienda.ID_AZIENDA,TIPO:this.tipo};
                utils.get("shared/azienda/detail",params, (response) => {
                    this.azienda = response.data;
					this.filters.openPopUp("popUpSchedaAzienda" + this.rs);
                    this.getTipologicaTipoAzienda();
                });
            }
            setTimeout(() => {
            }, 300);
        },	  

        getTipologicaTipoAzienda:function(){
            var idModulo = this.tipo == 1 ? 24 : 25;
            var campoMap = {
                'TIPOLOGIE': 'FK_ID_TIPOLOGIA_AZIENDA',
                'NETWORK':   'FK_ID_NETWORK',
                'PAGAMENTI': 'FK_ID_MODALITA_PAGAMENTO'
            };
            utils.get("shared/tipologica/lista", { FK_ID_MODULO: idModulo }, (responseTip) => {
                if (responseTip.esito != 0) return;
                this.arrayOpzioniAzienda = new Array();
                for (var i = 0; i < responseTip.data.length; i++) {
                    var tip = responseTip.data[i];
                    var campo = campoMap[tip.DESCRIZIONE];
                    if (campo == undefined) continue;
                    var opzioni = this.filters.getOpzioniTipologiche(tip.ID_TIPOLOGICA);
                    if (opzioni.length == 0) continue;
                    this.arrayOpzioniAzienda.push({
                        CAMPO:            campo,
                        LABEL:            tip.DESCRIZIONE,
                        FK_ID_TIPOLOGICA: tip.ID_TIPOLOGICA,
                        FK_ID_TIPO:       this.tipo,
                        FLG_MODIFICABILE: 0,
                        OPZIONI:          opzioni
                    });
                }
            });
        },

        salvaAzienda : function(){
			if (this.tabSelezionato == "datiAziendali"){
	            var api = this.azienda.ID_AZIENDA > 0 ? "shared/azienda/update" : "shared/azienda/insert";
	            this.azienda.FK_ID_TIPO = this.tipo;
	            utils.ajax(api,this.azienda, (response) => {
	                if (response.esito == 0){
	                    utils.alert.success(response.messaggio);
	                    if (!this.azienda.ID_AZIENDA > 0){
	                        this.azienda.ID_AZIENDA = response.id_inserito;
	                    }
	                    this.$emit("aziendaSalvata",this.azienda); 
	                    this.refreshAzienda();
						//this.filters.closePopUp("popUpSchedaAzienda");
	                }
	            });
			}
        }, 

        nuovoUtente : function(){
            this.utenteSelezionato = {ID_UTENTE:0,persona:{},FK_ID_LIVELLO:(this.tipo == 1 ? 4 : 3 ),FK_ID_ENTE:this.$root.idEnteCorrente,FK_ID_PERSONA_GIURIDICA:this.azienda.FK_ID_PERSONA_GIURIDICA};
            this.$refs.schedaUtente.openSchedaUtente(this.utenteSelezionato);
        }, 

        modificaUtente : function(utente){
            utils.get('core/utente/dettaglio',{ID_UTENTE:utente.ID_UTENTE}, (response) => {
                this.utenteSelezionato = response.data;
                this.$refs.schedaUtente.openSchedaUtente(response.data);
            });
        },	 

        refreshAzienda : function(){
            utils.get("shared/azienda/detail",{ID_AZIENDA:this.azienda.ID_AZIENDA}, (response) => {
                this.azienda = response.data;
            });
        },  
      
        resetPassword : function(utente){
            this.utenteSelezionato = utils.clone(utente);
            this.filters.openPopUp("modalPassword");  
        },

        doResetPassword : function(){
            this.filters.closePopUp('#modalPassword');
            utils.put('core/admin/utente/password/reset',this.utenteSelezionato, (response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                }  
            }); 
        },
        
        showNoteUtente : function(utente){
            this.utenteSelezionato = utils.clone(utente);
			this.filters.openPopUp("modalNoteUtente"); 
        },

        login : function(utente){
            utils.get('core/utente/dettaglio',{ID_UTENTE:utente.ID_UTENTE}, (response) => {
                if (response.esito == 0){
                    window.location.reload();
                }
            });
        }, 	   

        openUploadAzienda : function(azienda){
            this.$refs.avatarUpd.open({id: azienda.ID_AZIENDA, url: azienda.URL_AVATAR});
        },

        onAvatarUploaded : function(nomeAvatar){
            this.azienda.URL_AVATAR = nomeAvatar;
            utils.get("shared/azienda/detail",{ID_AZIENDA:this.azienda.ID_AZIENDA}, (response) => {
                if (response.esito == 0 && response.data){
                    this.azienda = response.data;
                }
                this.$emit("avatarAggiornato",this.azienda);
            });
        },

		comboCommissioniChangeHandler : function(){
			utils.alert.confirm("Sei sicuro di voler modificare tutte le commissioni?",()=>{
				for (var i = 0 ; i < this.azienda.commissioni.length ; i++){
					for (var j = 0 ; j < this.azienda.commissioni[i].OPZIONI.length ; j++){
						this.azienda.commissioni[i].OPZIONI[j].VALORE = this.commissioneMassiva;
					}
				}
				utils.alert.info("Le commissioni sono state massivamente modificate - Fare click sul pulsante SALVA");
			},this.$root);
		}
    
    }, 

    computed:{

    },



}
</script>

<style scoped>
@media (max-width: 767.98px) {
    .modal-body {
        height: auto;
        max-height: 75vh;
        overflow-y: auto;
    }
    .tableFixHead,
    .tableFixHeadRoles {
        overflow-x: auto;
        min-height: 0;
        max-height: 60vh;
    }
}
</style>
